import { useState } from "react"
import { GroupByType } from "../GroupByType"
import { DropDown } from "components/DropDown"

const viewCountTypes: Array<{ val: string, display: string }> = [
    {
        val: 'view_id',
        display: 'Views'
    },
    {
        val: 'user_key',
        display: 'Users'
    }
]

const clickCountTypes: Array<{ val: string, display: string }> = [
    {
        val: 'click_id',
        display: 'Clicks'
    },
    {
        val: 'user_key',
        display: 'Users'
    }
]

export const defaultGroupTypes: Array<{ val: string, display: string }> = [
    {
        val: 'country',
        display: 'Country'
    },
    {
        val: 'dj_type',
        display: 'DJ Type'
    },
    {
        val: 'membership',
        display: 'Plan'
    },
    {
        val: 'membership_library',
        display: 'Plan Library'
    },
    {
        val: 'membership_w_library',
        display: 'Plan/Library'
    }
]

export const useViewGrouping = () => {
    const [groupBy, setGroupBy] = useState<string | undefined>(undefined)
    const [countBy, setCountBy] = useState<string>(viewCountTypes[0].val)

    const countType = DropDown('count', viewCountTypes, countBy, (val) => setCountBy(val!), 'Count')

    const groupType = GroupByType(defaultGroupTypes, groupBy, setGroupBy, true, 'Group By')

    const toolbar = countType.concat(groupType)

    return { toolbar, parameters: { groupBy, countBy } }
}

export const useClickGrouping = () => {
    const [groupBy, setGroupBy] = useState<string | undefined>(undefined)
    const [countBy, setCountBy] = useState<string>(clickCountTypes[0].val)

    const countType = DropDown('count', clickCountTypes, countBy, (val) => setCountBy(val!), 'Count')

    const groupType = GroupByType(defaultGroupTypes, groupBy, setGroupBy, true, 'Group By')

    const toolbar = countType.concat(groupType)

    return { toolbar, parameters: { groupBy, countBy } }
}


// WEBPACK FOOTER //
// ./src/components/grouping/views.ts